import React from 'react';

export const TwitterLogo: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
    <path
      fill='#1DA1F2'
      d='M21 6.217a7.446 7.446 0 01-2.12.576 3.676 3.676 0 001.623-2.026 7.413 7.413 0 01-2.345.888A3.706 3.706 0 0015.463 4.5c-2.04 0-3.693 1.64-3.693 3.662 0 .286.033.564.095.832A10.518 10.518 0 014.253 5.17c-.317.543-.5 1.171-.5 1.84 0 1.27.653 2.392 1.643 3.048a3.709 3.709 0 01-1.672-.458v.047c0 1.773 1.272 3.253 2.962 3.589a3.75 3.75 0 01-1.668.063 3.691 3.691 0 003.45 2.541 7.452 7.452 0 01-4.586 1.568c-.299 0-.593-.018-.882-.052A10.512 10.512 0 008.66 19c6.794 0 10.508-5.577 10.508-10.414 0-.157-.004-.316-.011-.473a7.471 7.471 0 001.841-1.894L21 6.217z'
    ></path>
  </svg>
);
